import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Badge,
  UncontrolledTooltip,
  Col,
  Row,
  Button,
  Card,
} from "reactstrap";
import ReactBsTable from "components/Tables/ReactBsTable";
import DynamicFormModal from "components/Modal/Form";
import { userFormFields } from "variables/formFields";
import { publisherDealData } from "components/Common/constants";
import { DEFAULT_STATUS_LABELS } from "variables/constants";
import { showAlert } from "components/Common/commonFunctions";
import moment from "moment";
import SearchableDropdown from "components/DropDown/SearchableDropdown";
import { DATE_RANGE_OPTIONS } from "variables/constants";
import { createUser } from "actions/users";
import NotificationAlert from "react-notification-alert";
import { mapLabelsToValues } from "components/DropDown/MapLabelsToValues";
import { PRODUCT_TYPE_OPTIONS } from "variables/constants";
import { ROLE_OPTIONS } from "variables/constants";
import { getUserList } from "actions/users";
import { STATUS_OPTIONS } from "variables/constants";
import { mapValuesToLabels } from "components/DropDown/MapLabelsToValues";
import { getProductTypeList } from "actions/productType";
import { getUserDetails } from "actions/users";
import { updateUser } from "actions/users";
import { userresetPassword } from "actions/users";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const sortFieldMap = {
  name: "Name",
  email: "Email",
  role: "Role",
  row: "CreatedAt",
};

function UserList() {
  const [data, setData] = useState({ data: [], totalRecords: 0 });
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [showLoader, setshowLoader] = useState(false);
  const notificationAlertRef = useRef(null);
  const [pageNum, setPageNum] = useState(1);
  const [formState, setFormState] = useState({
    values: {
      status: true,
    },
    errors: {},
  });
  const [dropdownData, setDropdownData] = useState({
    productTypeData: {
      options: [],
      totalRecords: 0,
      pageNum: 1,
      searchString: "",
    },
  });
  const [sortConfig, setSortConfig] = useState({
    dataField: "",
    sortField: "",
    sortOrder: "",
  });

  const [filters, setFilters] = useState({
    name: "",
    email: "",
    product_type: "",
    date_range: "",
    start_date: "",
    end_date: "",
    status: "",
    filterParams: [],
  });

  const isEditMode = !!selected; // Check selected row is Edit mode or not.

  //=== User List Api call
  const getUsersListData = async () => {
    try {
      setshowLoader(true);
      const res = await getUserList(
        pageNum,
        filters.filterParams,
        "",
        sortConfig.sortField,
        sortConfig.sortOrder,
      );
      if (res.code === 200) {
        setData({
          data: res?.data?.User,
          totalRecords: res?.data?.totalRecords,
        }); // Set List Data according to api response.
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    } finally {
      setshowLoader(false);
    }
  };

  // COMBINED useEffect - removed separate sort useEffect
  useEffect(() => {
    getUsersListData();
    getDropDownData();
  }, [pageNum, filters.filterParams, sortConfig.sortField, sortConfig.sortOrder]);

  // REMOVED the separate sort useEffect - now combined with above

  const handleSortChange = (dataField, sortOrder) => {
    const mappedSortField = sortFieldMap[dataField] || dataField;
    setSortConfig({ dataField, sortField: mappedSortField, sortOrder });
    // setPageNum(1);
  };

  //===> getDropDownData function is used for call API's and patch list with dropdown.
  const getDropDownData = async () => {
    try {
      const productTypeRes = await getProductTypeList(
        dropdownData.productTypeData.pageNum,
        `[{"field":"Status","condition":"eq","filterValues":["ACTIVE"]}]`,
        dropdownData.productTypeData.searchString,
      );
      const productTypeData =
        productTypeRes?.code === 200
          ? (productTypeRes?.data?.ProductType || []).map((item) => ({
              label: item?.name || "",
              value: item?.ID,
            }))
          : [];
      setDropdownData((prev) => ({
        ...prev,
        productTypeData: {
          ...prev.productTypeData,
          options: productTypeData,
          totalRecords: productTypeRes?.data?.totalRecords || 0,
        },
      }));
    } catch (error) {}
  };

  //===> notify function is used for to show notification on create and update the deal.
  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };

  //==> handleChange function is used for set form values a state.
  const handleChange = (e) => {
    const name = e?.target?.name || e?.name;
    const value = e?.target?.value ?? e?.value;

    let error = "";

    // 🔹 Email validation
    if (name === "email" && value) {
      error = validators.email(value);
    }

    setFormState((prev) => ({
      values: {
        ...prev.values,
        [name]: value,
      },
      errors: {
        ...prev.errors,
        [name]: error, // clear error if valid
      },
    }));
  };

  //==> validators function  is used for apply validation while typing.
  const validators = {
    email: (value) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        ? ""
        : "Enter a valid email address",

    pocPhone: (value) =>
      /^[0-9]{10}$/.test(value) ? "" : "Phone number must be 10 digits",
  };

  //==> validateForm function is used for check form fields validate or not.
  const validateForm = () => {
    let newErrors = {};

    userFormFields(dropdownData?.productTypeData?.options).forEach((field) => {
      const value = formState.values[field.name];

      const isEmpty =
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0);

      // Required check (handles multiselect)
      if (field.required && isEmpty) {
        newErrors[field.name] = `${field.label} is required`;
        return;
      }

      // Pattern validation (email / phone)
      if (field.validate?.pattern && value && !Array.isArray(value)) {
        if (!field.validate.pattern.test(value)) {
          newErrors[field.name] = field.validate.message;
        }
      }
    });

    setFormState((prev) => ({
      ...prev,
      errors: newErrors,
    }));
    return Object.keys(newErrors).length === 0;
  };

  //==> handleSubmit function is used for create and update the user.
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setshowLoader(true);
    try {
      const payload = {
        ...formState.values,
        status: formState.values.status ? "ACTIVE" : "INACTIVE",
      };
      const res = !isEditMode
        ? await createUser(payload)
        : await updateUser(selected?.ID, payload);

      if (res.code === 200) {
        notify("success", res?.message);
        getUsersListData();
        setModalOpen(false);
        setSelected(null);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setshowLoader(false);
    }
  };

  //=> confirmStatus function is used for update the user status.
  const confirmStatus = async (data) => {
    try {
      let array = [];
      if (data?.productType?.length != null) {
        for (let i = 0; i < data?.productType.length; i++) {
          array.push(data?.productType[i]?.ID);
        }
      }
      let payload = {
        name: data?.name,
        email: data?.email,
        productType: array,
        role: mapLabelsToValues(data.role, ROLE_OPTIONS),
        status: data.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      const res = await updateUser(data?.ID, payload);
      if (res.code === 200) {
        notify("success", res?.message);
        getUsersListData();
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {}
  };

  //==> getUserDetailsById function is used for get user details by id to patch details on form.
  const getUserDetailsById = async (row) => {
    try {
      const res = await getUserDetails(row?.ID);
      if (res.code === 200) {
        let data = res?.data;
        let array = [];
        if (data?.productType?.length != null) {
          for (let i = 0; i < data?.productType.length; i++) {
            array.push(data?.productType[i]?.ID);
          }
        }

        setSelected(data);
        setFormState({
          values: {
            name: data?.name,
            email: data?.email,
            productType: array,
            role: mapLabelsToValues(data.role, ROLE_OPTIONS),
            status: data.status === "ACTIVE" ? true : false,
          },
          errors: {},
        });
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {}
  };

  //=> handleEdit function is used for open edit modal.
  const handleEdit = (row) => {
    try {
      getUserDetailsById(row);
      setSelected(row);
      setModalOpen(true);
    } catch (error) {}
  };

  useEffect(() => {
    if (!modalOpen) {
      setSelected(null);
      setFormState({
        values: {
          status: true,
        },
        errors: {},
      });
    }
  }, [modalOpen]);

  //=> handleStatusToggle function is used for to show Active and Inactive status modal.
  const handleStatusToggle = async (row) => {
    const isActive = row.status === "ACTIVE";
    const res = await getUserDetails(row?.ID);
    let data = res?.data;
    showAlert({
      title: `Are you sure you want to ${
        isActive ? "inactivate" : "activate"
      } this User?`,
      message: `User "${row.name}" will be ${
        isActive ? "inactive" : "active"
      }.`,
      type: "warning",
      confirmStyle: "secondary",
      cancelStyle: "btn btn-primary btn-gradient-primary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => confirmStatus(data),
      onCancel: () => {},
    });
  };

  // ===> columns is used for to show the columns on User List.
  const columns = [
    // {
    //   text: "Sr. No.",
    //   // formatter: (_, __, i) => i + 1,
    //   dataField: "srNo",
    //   formatter: (_, __, rowIndex) => (pageNum - 1) * 10 + rowIndex + 1,
    // },
    {
      dataField: "name",
      text: "Name",
      formatter: (_, row) => (row?.name != " " ? row?.name : "-"),
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "role",
      text: "Role",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "productType",
      text: "Products",
      formatter: (_, row) =>
        row?.productType != null
          ? row?.productType?.map((p) => p.name).join(", ")
          : "-",
    },
    {
      dataField: "row",
      text: "Created On",
      formatter: (_, row) => (row?.createdAt != null ? row?.createdAt : "-"),
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },

    {
      dataField: "status",
      text: "Status",
      formatter: (cell) => (
        <Badge color={cell === "ACTIVE" ? "success" : "danger"}>{cell}</Badge>
      ),
    },
    {
      text: "Actions",
      dataField: "actions",
      formatter: (_, row) => {
        const rowId = row.ID;
        return (
          <>
            <a
              id={`edit${rowId}`}
              className="table-action table-action-info"
              onClick={() => {
                handleEdit(row);
              }}
            >
              <i className="fas fa-edit" />
            </a>
            <UncontrolledTooltip target={`edit${rowId}`}>
              Edit
            </UncontrolledTooltip>

            <a
              className="table-action table-action-delete"
              id={`reset${rowId}`}
              onClick={(e) => {
                e.stopPropagation();
                handleResetPassword(row);
              }}
            >
              <i className="fa-solid fa-key" />
            </a>
            <UncontrolledTooltip target={`reset${rowId}`}>
              {"Reset Password"}
            </UncontrolledTooltip>
            <a
              className={`table-action table-action-delete ${
                row.status === "ACTIVE" ? "status-active" : "status-inactive"
              }`}
              id={`toggle${rowId}`}
              onClick={(e) => {
                e.stopPropagation();
                handleStatusToggle(row);
              }}
            >
              {row.status === "ACTIVE" ? (
                <i className="fa-solid fa-xmark" />
              ) : (
                <i className="fa-solid fa-check" />
              )}
            </a>
            <UncontrolledTooltip target={`toggle${rowId}`}>
              {row.status === "ACTIVE" ? "Mark Inactive" : "Mark Active"}
            </UncontrolledTooltip>
          </>
        );
      },
    },
  ];

  //==> handleResetPassword function is used for open reset modal.
  const handleResetPassword = (row) => {
    showAlert({
      title: "Reset Password?",
      message: `Password for "${row.name}" will be reset.`,
      type: "warning",
      confirmStyle: "secondary",
      cancelStyle: "btn btn-primary btn-gradient-primary",
      confirmText: "Reset",
      cancelText: "Cancel",
      onConfirm: () => {
        resetPassword(row);
      },
    });
  };

  // Publisher Reset Password Api
  const resetPassword = async (data) => {
    try {
      const res = await userresetPassword(data?.ID);
      if (res.code === 200) {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Mail Sent on you email";
        notify("success", message);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", error?.message);
    }
  };

  //==> showCustomDateInputs is used for Date Range dropdown.
  const showCustomDateInputs = (name, value) => {
    // handleChange(key, value);
    const today = moment().format("YYYY-MM-DD");

    if (value === "Custom Range") {
      setFilters((prev) => ({
        ...prev,
        date_range: value,
        start_date: "",
        end_date: "",
      }));
      // setShowCustomDate(true);
      return;
    }

    let months = 0;
    if (value === "Last 1 Month") months = 1;
    if (value === "Last 3 Month") months = 3;
    if (value === "Last 6 Month") months = 6;
    if (value === "Last 12 Month") months = 12;

    const startDate = moment().subtract(months, "months").format("YYYY-MM-DD");

    setFilters((prev) => ({
      ...prev,
      date_range: value,
      start_date: startDate,
      end_date: today,
    }));
    // setShowCustomDate(true);
  };

  //==> buildFilterParams function is used for make filterJson array.
  const buildFilterParams = () => {
    const filterParams = [];

    if (filters?.status !== "") {
      filterParams.push({
        field: "Status",
        condition: "eq",
        filterValues: [filters?.status],
      });
    }
    if (filters?.product_type !== "") {
      filterParams.push({
        field: "ProductTypeID",
        condition: "eq",
        filterValues: [String(filters?.product_type)],
      });
    }

    if (filters?.name !== "") {
      filterParams.push({
        field: "Name",
        condition: "like",
        filterValues: [filters?.name],
      });
    }

    if (filters?.email !== "") {
      filterParams.push({
        field: "Email",
        condition: "like",
        filterValues: [filters?.email],
      });
    }

    if (filters?.start_date !== "" && filters?.end_date !== "") {
      filterParams.push({
        field: "CreatedAt",
        condition: "btw",
        filterValues: [filters?.start_date, filters?.end_date],
      });
    }

    return filterParams.length > 0 ? JSON.stringify(filterParams) : [];
  };

  //===> handleFilterChange function is used for set filters values in a state.
  const handleFilterChange = (key, value) => {
    setFilters((prev) => {
      if (key === "start_date") {
        const startDate = value;
        const endDate = prev.end_date;

        // if end_date exists AND start_date <= end_date → keep end_date
        if (endDate && new Date(startDate) <= new Date(endDate)) {
          return {
            ...prev,
            start_date: startDate,
          };
        }

        // otherwise reset end_date
        return {
          ...prev,
          start_date: startDate,
          end_date: "",
        };
      }

      return {
        ...prev,
        [key]: value,
      };
    });
  };

  //==> isAnyFilterApplied function is used for to check is any filter is applied or not to avoid api call.
  const isAnyFilterApplied = (filters) => {
    return Object.entries(filters).some(([key, value]) => {
      if (key === "filterParams") {
        return Array.isArray(value) && value.length > 0;
      }
      return value !== "" && value !== null && value !== undefined;
    });
  };

  //==> handleSearch function is used for search the filters values in a list.
  const handleSearch = () => {
    if (!isAnyFilterApplied(filters)) return;
    const newfilterParams = buildFilterParams();

    setFilters({
      ...filters,
      filterParams: newfilterParams,
    });
    if (pageNum !== 1) setPageNum(1);
  };

  //==> formatDate function is used for to show filter date in human readble.
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  //==> handleReset function is used for reset filters values.
  const handleReset = () => {
    if (!isAnyFilterApplied(filters)) return;
    setFilters({
      name: "",
      email: "",
      product_type: "",
      date_range: "",
      start_date: "",
      end_date: "",
      status: "",
      filterParams: [],
    });
  };

  //==> filterSection is used for show filters on list.
  const filterSection = () => {
    return (
      <>
        <Row className="align-items-center">
          <Col md={2}>
            <input
              className="form-control"
              placeholder={"Name"}
              value={filters.name}
              onChange={(e) => handleFilterChange("name", e.target.value)}
            />
          </Col>
          <Col md={2}>
            <input
              className="form-control"
              placeholder={"Email"}
              value={filters.email}
              onChange={(e) => handleFilterChange("email", e.target.value)}
            />
          </Col>
          <Col md={2}>
            <SearchableDropdown
              options={dropdownData.productTypeData.options}
              placeholder="Product Type"
              value={filters.product_type}
              onChange={(e) =>
                handleFilterChange("product_type", e.target.value)
              }
              isSearchable={false}
            />
          </Col>

          <Col md={2}>
            <SearchableDropdown
              options={STATUS_OPTIONS}
              placeholder="Status"
              value={filters.status}
              onChange={(e) => handleFilterChange("status", e.target.value)}
              isSearchable={false}
            />
          </Col>
        </Row>

        <Row className="mt-2">
          <>
            <Col md={2}>
              <SearchableDropdown
                options={DATE_RANGE_OPTIONS}
                placeholder="Date Range"
                value={filters.date_range}
                onChange={(e) =>
                  showCustomDateInputs("date_range", e.target.value)
                }
                isSearchable={false}
              />
            </Col>
            <Col md={2}>
              <div className="datepicker-wrapper">
                <DatePicker
                  selected={
                    filters.start_date ? new Date(filters.start_date) : null
                  }
                  onChange={(date) =>
                    handleFilterChange(
                      "start_date",
                      date ? formatDate(date) : "",
                    )
                  }
                  dateFormat="dd MMM yyyy"
                  placeholderText="Start Date"
                  className="form-control custom-datepicker"
                  disabled={filters.date_range !== "Custom Range"}
                />
                <i className="ni ni-calendar-grid-58 text-muted calendar-icon" />
              </div>
            </Col>

            <Col md={2}>
              <div className="datepicker-wrapper">
                <DatePicker
                  selected={
                    filters.end_date ? new Date(filters.end_date) : null
                  }
                  onChange={(date) =>
                    handleFilterChange("end_date", date ? formatDate(date) : "")
                  }
                  dateFormat="dd MMM yyyy"
                  placeholderText="End Date"
                  className="form-control custom-datepicker"
                  /* ✅ disable until start date is selected */
                  disabled={
                    filters.date_range !== "Custom Range" || !filters.start_date
                  }
                  /* ✅ minDate must be a Date object */
                  minDate={
                    filters.start_date
                      ? new Date(filters.start_date)
                      : undefined
                  }
                />
                <i className="ni ni-calendar-grid-58 text-muted calendar-icon" />
              </div>
            </Col>
          </>
          <Col md={4}>
            <Button
              onClick={handleSearch}
              disabled={!isAnyFilterApplied(filters)}
              className="filter-btn-gradient-primary btn-md responsive"
            >
              Search
            </Button>

            <Button
              // className="filter-btn-gradient-secondary btn-md responsive"
              className="secondary"
              disabled={!isAnyFilterApplied(filters)}
              onClick={handleReset}
            >
              Reset
            </Button>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Container className="mt--6" fluid>
        <Card>
          <ReactBsTable
            title="Users"
            description="Manage Users"
            data={data?.data}
            columns={columns}
            keyField="ID"
            addbtntext="Add User"
            onAddBtnClick={() => {
              setSelected(null);
              setFormState({
                values: { status: true },
                errors: {},
              });
              setModalOpen(true);
            }}
            renderFilters={filterSection}
            page={pageNum}
            sizePerPage={10}
            defaultSortField={sortConfig.dataField}
            defaultSortOrder={sortConfig.sortOrder}
            totalRecords={data?.totalRecords}
            onPageChange={(p) => setPageNum(p)}
            showLoader={showLoader}
            onSortChange={handleSortChange}
          />
        </Card>
      </Container>

      <DynamicFormModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        title={isEditMode ? "Edit User" : "Add User"}
        fields={userFormFields(dropdownData?.productTypeData?.options)}
        formData={formState.values}
        errors={formState.errors}
        onChange={handleChange}
        onSubmit={handleSubmit}
        formState={formState}
        setFormState={setFormState}
        isEditMode={isEditMode}
        trueLabel={DEFAULT_STATUS_LABELS.active}
        falseLabel={DEFAULT_STATUS_LABELS.inactive}
        showLoader={showLoader}
      />
    </>
  );
}
export default UserList;